






























































import Vue from 'vue';
import PracticeListing from '@/components/PracticeListing.vue';
import SearchBar from '@/components/SearchBar.vue';
import UserIcon from '@/components/UserIcon.vue';

export default Vue.extend({
  name: 'Search',
  components: {
    PracticeListing,
    SearchBar,
    UserIcon,
  },
  props: {
    page: {
      type: Number,
      default: 1,
    },
    type: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      loading: true,
      practices: [],
      practicesCount: 0,
      // @ts-ignore - ignoring this for this version, to be fixed in Nuxt implementation
      search: this.$options.filters.normalizeString(this.$route.query.s),
      teachers: [],
      teachersCount: 0,
    };
  },
  created() {
    if (!this.search) {
      this.$router.push({
        name: 'community',
      });
    }
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    $route: 'routeChanged',
  },
  filters: {
    normalizeString(value: string | undefined) {
      if (!value) {
        return undefined;
      }

      const val = value.trim();

      if (!val.length) {
        return undefined;
      }

      return val;
    },
  },
  methods: {
    fetchData() {
      // Reassign this scope for callback usage
      const component = this;

      fetch(`https://api.pocketyoga.com/profiles?search_term=${this.search}&count=true&limit=4`, {
        headers: { version: '5' },
      })
        .then((teachersResponse) => {
          if (!teachersResponse.ok) {
            throw teachersResponse;
          }

          return teachersResponse.json();
        })
        .then((teachers) => {
          component.teachers = teachers.data;
          component.teachersCount = teachers.count;

          fetch(`https://api.pocketyoga.com/practices?search_term=${this.search}&count=true&search_teachers=true&limit=3`, {
            headers: { version: '5' },
          })
            .then((practicesResponse) => {
              if (!practicesResponse.ok) {
                throw practicesResponse;
              }

              return practicesResponse.json();
            })
            .then((practices) => {
              component.practices = practices.data;
              component.practicesCount = practices.count;
              component.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearchChange(search: string | null) {
      if (search === null) {
        this.$router.push({
          name: 'community',
        });
      } else {
        this.$router.push({
          name: 'search',
          query: {
            s: search,
          },
        });
        this.practices = [];
        this.teachers = [];
      }
    },
    routeChanged() {
      // @ts-ignore - ignoring this for this version, to be fixed in Nuxt implementation
      this.search = this.$options.filters.normalizeString(this.$route.query.s);
      this.fetchData();
    },
  },
});
